<template>
  <section class="table-sampler-memory-chemical">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Instrumento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Instrumento"
          v-model="model.instrument"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Calibrador</label>
        <input
          type="text"
          class="form-control"
          placeholder="Calibrador"
          v-model="model.gauge"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.gauge_serie"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.gauge_certificate"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.gauge_validity"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Data</label>
        <input
          type="text"
          class="form-control"
          placeholder="Data"
          v-model="model.date"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Agente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Agente"
          v-model="model.agent"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Método</label>
        <input
          type="text"
          class="form-control"
          placeholder="Método"
          v-model="model.method"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo de amostrador</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de amostrador"
          v-model="model.sampler_type"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>N.º Branco de campo</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º Branco de campo"
          v-model="model.white_field_no"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Vazão da bomba <small>(L/min)</small></label>
        <input
          type="text"
          class="form-control"
          placeholder="Vazão da bomba"
          v-model="model.pump_flow"
          required
        />
      </d-col>
      <d-col cols="1">
        <label>Volume <small>(L)</small></label>
        <input
          type="number"
          class="form-control"
          placeholder="Volume"
          v-model="model.volume"
          required
        />
      </d-col>
      <d-col cols="auto">
        <label>Temperatura <small>(C˚)</small></label>
        <input
          type="number"
          class="form-control"
          placeholder="Temperatura"
          v-model="model.temperature"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>URL inicial<small>(%)</small></label>
        <input
          type="number"
          class="form-control"
          placeholder="URL inicial"
          v-model="model.initial_ura"
          required
        />
      </d-col>
      <d-col cols>
        <label>Pressão atmosférica</label>
        <input
          type="number"
          class="form-control"
          placeholder="Pressão atmosférica"
          v-model="model.atmospheric_pressure"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Horário inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário inicial"
          v-model="model.initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Horário final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário final"
          v-model="model.final"
          required
        />
      </d-col>
      <d-col cols>
        <label>Intervalo inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Intervalo inicial"
          v-model="model.interval_initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Intervalo final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Intervalo final"
          v-model="model.interval_final"
          required
        />
      </d-col>
      <d-col cols>
        <label>Tempo total</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tempo total"
          v-model="model.total_time"
          required
        />
      </d-col>
    </d-form-row>

    <epi-list :list.sync="model.epis"></epi-list>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        ></textarea>
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { CHEMICAL_MEMORY, _LOAD_MODEL_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';

export default {
  name: 'Sample-Memory-Chemical',
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(CHEMICAL_MEMORY),
    };
  },
  components: {
    EpiList,
  },
  methods: {
    setModel() {
      if (this.memory) {
        this.model = this.memory;
      }
    },
  },
  mounted() {
    this.setModel();
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:memory', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-chemical {
  label {
    margin-bottom: 0;
  }
}
</style>
